import Component from '@glimmer/component';
import { isDevelopingApp, macroCondition } from '@embroider/macros';
import { t } from 'ember-intl';
import { HdsAlert } from '@hashicorp/design-system-components/components';

import type Owner from '@ember/owner';

interface HvnSelectZeroStateDefaultContentSignature {
  // eslint-disable-next-line @typescript-eslint/ban-types
  Args: {};
}

export default class FormInputsHvnSelectZeroStateDefaultContent extends Component<HvnSelectZeroStateDefaultContentSignature> {
  constructor(
    owner: Owner,
    args: HvnSelectZeroStateDefaultContentSignature['Args']
  ) {
    super(owner, args);

    if (macroCondition(isDevelopingApp())) {
      console.error(
        `WHOOPS !!! You should ONLY see \`<HvnSelect.ZeroStateDefaultContent>\` as a fallback in testing environments.
Please provide a custom zero state for \`<HvnSelect>\` to render using by passing a \`<:zero-state>\` named block content instead.`
      );
    }
  }

  <template>
    <div data-test-form-inputs-hvn-select-zero-state-default-content>
      <HdsAlert @type="inline" @color="neutral" as |A|>
        <A.Description>
          {{t
            "components.form-inputs.hvn-select.zero-state-default-content.banner.header"
          }}
        </A.Description>
      </HdsAlert>
    </div>
  </template>
}
